import React from 'react';
import { Link } from 'react-router-dom';
import { FiEdit } from 'react-icons/fi'; // Ícone para o botão

import { Card, Container, Content } from './styles';
import AdminHeader from '~/components/Admin/Header';
import Footer from '~/components/Footer';

const Dashboard: React.FC = () => {
  return (
    <Container>
      <AdminHeader />

      <Content>
        <h2>Acessos Rápidos</h2>

        <Link to="/admin/blog">
          <Card>
            <FiEdit size={32} />
            <strong>Gerenciar Blog</strong>
            <p>Adicione, remova e reordene os posts do LinkedIn.</p>
          </Card>
        </Link>
      </Content>
      <Footer message="" />
    </Container>
  );
};

export default Dashboard;
